module.exports = __webpack_public_path__ + "img/stop_btn.3979219c.png";